/**
 * Created by alberto on 2014-11-28.
 */
define('payment/handlers/paymentMethodHandlers/siruMethodHandler',['jquery'],

    function($) {
        'use strict';

        function setupFormTemplate(paymentBox) {
            var $input = paymentBox.$box.find('.amount-box').find('input');
            $input.prop('disabled', true);
        }

        var siru = {};
        siru.setupFormTemplate = setupFormTemplate;

        return siru;
    }
);

